import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam, AnyType } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";
import { toLocaleString } from "./common";

type InternalSimulatorRow = AnyType;

export interface IGetSimulatorsResponceModel {
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * シミュレータID
   */
  simulatorid: string;
  /**
   * シミュレータ名
   */
  name: string;
  /**
   * シミュレータ作成日時
   */
  simcreatetime: string;
}

export interface ISimulatorRow extends IGetSimulatorsResponceModel {
  id: number;
}

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIからシミュレータ一覧の取得が成功した場合に呼び出されます
   * @callback success
   * @param {ISimulatorRow[]} rows - シミュレータ一覧
   * @param {number} status - httpステータス
   */
  success: (rows: ISimulatorRow[], status: number) => void;
}



function createRow(index: number, row: InternalSimulatorRow): ISimulatorRow {
  row.id = index;
  row.simcreatetime = toLocaleString(new Date(Date.parse(row.simcreatetime)));
  return row;
}

function createRows(data: IGetSimulatorsResponceModel[]): ISimulatorRow[] {
  if (Array.isArray(data)) {
    const rows: InternalSimulatorRow[] = data.slice();
    rows.forEach((row, i) => {
      row = createRow(i, row);
    });
    return rows;
  } else {
    return [createRow(0, data)];
  }
}

function AxiosGet(url: string, token?: string) {
  if (token) {
    return axios.get(url, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axios.get(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(createRows(res.data), res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

/**
 * リクエストURIに含まれるID類
 */
export interface IGetSimulatorsParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
}


/**
 * シミュレータ一覧を取得します
 * @function getSimulators
 * @param {IGetSimulatorsParams} params - シミュレータ一覧取得パラメータ
 */
export function getSimulator(params: IGetSimulatorsParams): void {
  const { 
    authService, 
    projectid,
  } = params;
  const url = WebAPI.GET_SIMULATOR(projectid);
  /*if (simulatorid) {
    url = url + "/" + simulatorid;
  }*/
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosGet(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              getSimulatorRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosGet(url),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * シミュレータ一覧を取得します
 * @function getSimulatorsRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function getSimulatorRetry401(
  authService: AuthService,
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosGet(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
